import DashboardLayout from '../../components/dashboard/DashboardLayout';
import RateMyStayContent from '../../components/dashboard/RateMyStay';

const RateMyStayPage = () => {
  return (
    <DashboardLayout>
      <RateMyStayContent />
    </DashboardLayout>
  );
};

export default RateMyStayPage; 